import createPostingPreview from '../../views/nominal/NominalPostingPreviewForm';
import createPostedTransactions from '../../views/nominal/PostedTransactionsForm';
import { InfoButton } from '../../components/connectedForm/Button';
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from '../../utils/BackgroundJobs';
import SalesBadDebtPostMutation from '../../graphql/mutations/salesLedger/SalesBadDebtPostMutation.graphql';
import SalesBadDebtAutoWriteOffMutation from '../../graphql/mutations/salesLedger/SalesBadDebtAutoWriteOffMutation.graphql';
import SalesBadDebtPostingPreview from '../../graphql/entities/salesLedger/SalesBadDebtPostingPreview';
import SalesBadDebtTransactions from '../../graphql/entities/salesLedger/SalesBadDebtTransactions';
import updateStoreFieldValues from '../../components/connectedForm/utils/updateStoreFieldValues';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';
import { DocumentStatus, ISalesBadDebt } from '../../graphql/schema/p4types';

const autoWriteOff: (props: any) => void = (props) => {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(
    SalesBadDebtAutoWriteOffMutation,
    input,
    props,
    null,
    'Auto Write Off',
    updateStoreFieldValues
  );
};

const displayPreview: (badDebt: ISalesBadDebt) => void = (badDebt) => {
  if (badDebt && badDebt.documentStatus) {
    return badDebt.documentStatus === DocumentStatus.Draft || badDebt.documentStatus === DocumentStatus.Released;
  }
  return false;
};

const displayPosted: (badDebt: ISalesBadDebt) => boolean = (badDebt) => {
  if (badDebt && badDebt.documentStatus) {
    return badDebt.documentStatus === DocumentStatus.Posted;
  }
  return false;
};

const canBePosted: (badDebt: ISalesBadDebt) => boolean = (badDebt) => {
  if (badDebt && badDebt.documentStatus) {
    return badDebt.documentStatus === DocumentStatus.Draft || badDebt.documentStatus === DocumentStatus.Released;
  }
  return false;
};

const postBadDebt: (props: any) => void = (props) => {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(SalesBadDebtPostMutation, input, props, 'back', 'Post Bad Debt', null);
};

const SALES_BAD_DEBT_POSTING_PREVIEW = createPostingPreview(SalesBadDebtPostingPreview);
const SALES_BAD_DEBT_POSTED_TRANSACTIONS = createPostedTransactions(SalesBadDebtTransactions);

export const formActions = [
  {
    description: 'Preview Postings',
    triggerModal: {
      modalContent: SALES_BAD_DEBT_POSTING_PREVIEW,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Postings/salesLedger/SalesBadDebt',
        forceReadOnly: true,
      },
    },
    performSave: true,
    saveMessage: 'Nominal/VAT Postings Preview',
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPreview,
  },
  {
    description: 'View Transactions',
    triggerModal: {
      modalContent: SALES_BAD_DEBT_POSTED_TRANSACTIONS,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Transactions/salesLedger/SalesBadDebt',
        forceReadOnly: true,
      },
    },
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPosted,
  },
  {
    description: 'Auto Write Off',
    component: InfoButton,
    fn: autoWriteOff,
    individualButton: true,
    performSave: true,
    saveMessage: 'Invoices written off',
    condition: canBePosted,
  },
  {
    description: 'Post Bad Debt',
    component: PostSelectButton,
    performSave: true,
    fn: postBadDebt,
    individualButton: true,
    saveMessage: 'Bad Debt Posted',
    condition: canBePosted,
  },
];
